var _path, _path2, _rect, _path3, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrownGlassTubeFullOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 100,
    viewBox: "0 0 33 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.46069 18H25.4607V91.7662C25.4607 95.209 22.4386 98 18.7107 98H14.2107C10.4828 98 7.46069 95.209 7.46069 91.7662V18Z",
    fill: "#462316"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46069 18H23.4607V90.8658C23.4607 93.7013 21.2221 96 18.4607 96H14.4607C11.6993 96 9.46069 93.7013 9.46069 90.8658V18Z",
    fill: "#7D5547"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.46069,
    y: 16,
    width: 20,
    height: 2,
    rx: 1,
    fill: "#462316"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46069 35H23.4607V90.6056C23.4607 93.5848 21.2221 96 18.4607 96H14.4607C11.6993 96 9.46069 93.5848 9.46069 90.6056V35Z",
    fill: "#291906"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.46069,
    y: 43,
    width: 15,
    height: 19,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22.4607,
    y: 43,
    width: 2,
    height: 19,
    fill: "#EEEEEE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4607,
    y: 43,
    width: 1,
    height: 19,
    fill: "#CCCCCC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.46069,
    y: 43,
    width: 1,
    height: 19,
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrownGlassTubeFullOpen);
export default __webpack_public_path__ + "static/media/brown_glass_tube_full_open.d214e46006e32407f47c9fc2cdeb8738.svg";
export { ForwardRef as ReactComponent };